import * as types from './types';

export const setForm = ({ commit }, payload) => {
  commit(types.SET_FORM, payload);
};

export default {
  setForm
};



// WEBPACK FOOTER //
// ./src/store/modules/customer/actions.js